export const getDesignPreviewUrl = (url: string, width = 330): string => {
  // TODO: why is 330 hardcoded?
  if (!url) {
    return '';
  }

  // Append requestor field if not already present
  if (!url.includes('requestor=')) {
    url += (url.includes('?') ? '&' : '?') + 'requestor=localization-ui';
  }

  const encodedAdtifUrl = encodeURIComponent(url);
  const documentUri = `https://instructions.documents.cimpress.io/v3/instructions:preview?type=preview&documentUri=${encodedAdtifUrl}`;
  const documentUriEncoded = encodeURIComponent(documentUri);
  const imageUri = `https://rendering.documents.cimpress.io/v1/cse/preview?format=jpeg&width=${width}&instructions_uri=${documentUriEncoded}`;
  return imageUri;
};
